import React, { useMemo } from "react";
import { OverviewListTable } from "@icoach/components";
import { Icons, IconButton, InputAdornment, TextField } from "@curves/ui-base";
import { BatchControllerBoxContainer } from "@icoach/batchPayment/component/BatchActionTable";
import useSearch from "@util/hook/useSearch";
import usePrivacyToggle, { securityMaskFilterTypeMap } from "@util/hook/usePrivacyToggle";
import { getDebitCashRowsLabel } from "@icoach/batchPayment/component/DebitCashRowsLabelTemplate";

const DebitListForCash = ({ headerRow, list, dialogRef, refresh }) => {
	const { isRevealed, doTogglePrivacy, renderPrivacyIcon } = usePrivacyToggle();
	const { updateSearchKeyword, filteredData, inputRef, handleChange, handleComposition } = useSearch(list, ["memberName"]);

	// 開啟隱碼
	const handleToggleRevealed = () => {
		const apiParams = {
			filterType: securityMaskFilterTypeMap.ClubEmployeeOverview,
			totalCount: filteredData.length,
		};
		doTogglePrivacy(apiParams);
	};

	const defaultHeaderRow = useMemo(
		() => {
			return getDebitCashRowsLabel();
		},
		// eslint-disable-next-line
		[]
	);
	return (
		<>
			<BatchControllerBoxContainer>
				{renderPrivacyIcon(handleToggleRevealed)}
				<TextField
					style={{ maxWidth: "260px" }}
					ref={inputRef}
					placeholder={"搜尋會員"}
					InputProps={{
						endAdornment: (
							<InputAdornment position={"end"}>
								<IconButton onClick={updateSearchKeyword}>
									<Icons.Magnifier />
								</IconButton>
							</InputAdornment>
						),
					}}
					onCompositionStart={handleComposition}
					onCompositionUpdate={handleComposition}
					onCompositionEnd={handleComposition}
					onChange={handleChange}
				/>
			</BatchControllerBoxContainer>
			<OverviewListTable
				className={"debit-list-table"}
				list={filteredData}
				headerRow={headerRow ? headerRow : defaultHeaderRow}
				tableRowBodyProps={{
					dialogRef,
					refresh,
					isRevealed,
				}}
				isGray
			/>
		</>
	);
};

export default DebitListForCash;
